import parseStoreHours from './parse-store-hours';

/**
 * Store Details Neraby
 * @param {object} opts
 */
function storeDetailsNearby(opts) {
  const config = {
    dom: {
      main: 'nearbyStores',
      items: 'js-nearby-stores-items',
      wrapper: 'js-nearby-stores-wrapper',
    },
    cls: {
      hide: 'hide',
    },
  };
  const c = __.extend(config, opts);

  // global elements
  const $main = document.getElementById(c.dom.main);

  // global data
  const widgetTag = SDG.Data.stockistWidgetTag || null;
  const storage = window.sessionStorage;
  let storesJson = storage?.getItem('allStores');
  let allStores = storesJson ? JSON.parse(storesJson) : null;
  const storeName = SDG.Data.storeName || null;

  /**
   * Init
   */
  function init() {
    if (!$main) return;

    const timeout = 1000;

    setTimeout(() => {
      getNearbyStores();
    }, timeout);
  }

  /**
   * Get Nearby Stores
   */
  function getNearbyStores() {
    // get fresh stores session data
    if (!allStores) {
      storesJson = storage?.getItem('allStores');
      allStores = storesJson ? JSON.parse(storesJson) : null;
    }

    if (!allStores) {
      console.error('no allStores data:', allStores);
      return;
    }

    const currentStore = allStores.find((store) => store.name === storeName);
    if (!currentStore) {
      console.error(`no currentStore found for ${storeName}:`, allStores);
      return;
    }

    getStoreData(currentStore);
  }

  /**
   * Gets Stockist store location data
   * @param {object} currentStore
   */
  async function getStoreData(currentStore) {
    const { latitude, longitude } = currentStore;

    // Get Stockist data
    await fetch(`https://stockist.co/api/v1/${widgetTag}/locations/search?latitude=${latitude}&longitude=${longitude}`)
      .then((resp) => resp.json())
      .then((data) => {
        const stores = data.locations;
        displayNearestStores(stores);
      })
      .catch((err) => console.error(err));
  }

  /**
   * Display nearest stores (max of 3)
   */
  function displayNearestStores(stores) {
    const storesWithin25 = stores.filter((store) => store.distance <= 25);
    const closestStores = storesWithin25.length >= 1
      ? storesWithin25.slice(1, 4)
      : null;
    if (!closestStores?.length) return;

    // max of 3 and ignore the closest location (current store)
    buildNearestStores(closestStores);
  }

  /**
   * Build Nearest Stores
   */
  function buildNearestStores(closestStores) {
    const $wrapper = $main?.querySelector(`.${c.dom.wrapper}`);
    const $items = $main?.querySelector(`.${c.dom.items}`);
    if (!$items || !$wrapper) return;

    let html = '';
    closestStores.forEach((store) => {
      const storePageUrl = `/pages/${__.handleize(store.name)}`;
      const imageSize = 832;
      const dataWidths = __.getImageSizes(imageSize);
      const storeHoursData = store.custom_fields.filter(
        (customField) => customField.name.includes('Store Hours'),
      );

      let storeHoursText = '';
      if (storeHoursData?.length) {
        storeHoursText = parseStoreHours(storeHoursData);
      }

      html += `
        <a
          class="store-details-nearby__item store__grid-card"
          href="${storePageUrl}"
          title="${storePageUrl}"
        >
          <div class="store-details-nearby__image">
            <div class="ir ir--store-grid-image is-loading store-grid__image-wrapper">
              <img
                class="lazyload store-details__image store-grid__image"
                data-widths="${dataWidths}"
                data-sizes="auto"
                tabindex="-1"
                alt=""
                data-src="${store.image_url}"
              >
            </div>
          </div>
          <div class="store-details-nearby__details store__grid-card-details">
            <div class="store-details-nearby__column store__grid-card-address">
              <h3 class="store-details-nearby__title store__grid-card-title">
                ${store.name}
              </h3>
              <p class="store-details-nearby__text store__grid-card-text">
                ${store.address_line_1}
              </p>
              <p class="store-details-nearby__text store__grid-card-text">
                ${store.city}, ${store.state} ${store.postal_code}
              </p>
            </div>
            <div class="store-details-nearby__column store__grid-card-info">
              <p class="store-details-nearby__text store__grid-card-text">
                ${storeHoursText}
              </p>
              <p class="store-details-nearby__link store__grid-card-link">
                Store Details
              </p>
            </div>
          </div>
        </a>
      `;
    });

    $items.innerHTML = html.trim();
    __.removeClass($wrapper, c.cls.hide);
  }

  return init();
}

export default storeDetailsNearby;
